export default "__VITE_ASSET__7E7c013o__"